import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=a7b8abe8&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b8abe8",
  null
  
)

export default component.exports